import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { throttle } from 'lodash';

@Component
export class StickyFooterBar extends ThemeComponent {

    @Prop({ default: null }) scrolltarget!: string;

    private scrollTargetElement!: Element | null;

    constructor() {
        super();
    }

    init() {
        // The scroll target element is the element we check has been scrolled past
        this.scrollTargetElement = document.querySelector(this.scrolltarget);

        this.addEventListener('DropdownActive', () => {
            document.body.classList.add('overlay--active');
        });

        this.addEventListener('DropdownInactive', () => {
            document.body.classList.remove('overlay--active');
        });


        if (this.scrollTargetElement) {
            this.observeScroll();
        }

        window.addEventListener('scroll', throttle(() => {
            this.handleDropdownOpenState();
        }, 200, { trailing: false, leading: false }));
    }

    observeScroll() {
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 0.1
        };

        if ('IntersectionObserver' in window) {
            const stickyBarObserver = new IntersectionObserver((entries, observer) => {
                if (!entries[0].isIntersecting) {
                    document.body.classList.add('sticky-footer-bar--active');
                }else {
                    document.body.classList.remove('sticky-footer-bar--active');
                    this.handleDropdownOpenState();
                }
            }, options);

            if (this.scrollTargetElement) {
                stickyBarObserver.observe(this.scrollTargetElement);
            }
        }
    }

    handleDropdownOpenState() {
        if (this.querySelector('.dropdown-button--active')) {
            const activeDropdown = this.querySelector('.dropdown-button--active');
            activeDropdown?.classList.remove('dropdown-button--active');
            document.body?.classList.remove('overlay--active');
        }
    }

}
